var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLower = function SvgLower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 2.5,
    stroke: "#16a34a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.546 9V3.784h1.176v4.224h2.064V9h-3.24Z",
    fill: "#16a34a"
  })));
};
export { SvgLower as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='100%25' height='100%25' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='0.5' y='0.5' width='11' height='11' rx='2.5' stroke='%2316a34a'/%3E %3Cpath d='M4.54569 9V3.784H5.72169V8.008H7.78569V9H4.54569Z' fill='%2316a34a'/%3E %3C/svg%3E";